import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import moment from 'moment';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import { Tour } from 'src/app/model/tour/tour';
import { SnackService } from 'src/app/services/snack.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { EmployeeDateTourControllerRequestService } from '../../employee-tour-list/employee-tour/service/employee-date-tour-controller-request.service';
import { IPInstallerListControllerRequestService } from '../../service/ip-installer-list-controller-request.service';
import { TourDateChangeService } from '../../service/tour-date-change.service';
import {
  TourPreviewSelectorModalHelper,
  TourPreviewSelectorObject,
} from './helper/tour-preview-selector-modal-helper';

@Component({
  selector: 'tour-preview-selector-modal',
  templateUrl: './tour-preview-selector-modal.component.html',
  styleUrls: ['./tour-preview-selector-modal.component.scss'],
})
export class TourPreviewSelectorModalComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Output()
  requestedTours = new EventEmitter<Tour[]>();

  placers: Employee[];
  today = new Date();

  init: boolean = false;
  loading: boolean = false;

  firstSelectorObject: TourPreviewSelectorObject = {};
  secondSelectorObject: TourPreviewSelectorObject = {};

  constructor(
    public dialogRef: MatDialogRef<TourPreviewSelectorModalComponent>,
    private ipInstallerListControllerRequestService: IPInstallerListControllerRequestService,
    private employeeDateTourControllerRequestService: EmployeeDateTourControllerRequestService,
    private snackService: SnackService,
    private tourDateChangeService: TourDateChangeService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ipInstallerListControllerRequestService
      .IPInstallerList()
      .then((placers: Employee[]) => {
        this.placers = placers;
        this.init = true;
      });

    this.addSubscription(
      this.tourDateChangeService.getTourDateSubject(),
      (date: moment.Moment) => {
        const firstDate = moment(date).toDate();
        const secondDate = moment(date).add(1, 'd').toDate();
        this.firstSelectorObject.date1 = firstDate;
        this.firstSelectorObject.date2 = secondDate;
        this.secondSelectorObject.date1 = firstDate;
        this.secondSelectorObject.date2 = secondDate;
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  async loadPreviews(): Promise<void> {
    this.loading = true;

    const requestObjects =
      TourPreviewSelectorModalHelper.convertToMultiplePlacerToursRequestObjects(
        [this.firstSelectorObject, this.secondSelectorObject]
      );
    if (!CollectionHelper.isPopulated(requestObjects)) {
      this.snackService.showError(
        'Gelieve minstens één installateur en datum te kiezen'
      );
      this.loading = false;
      return;
    }

    try {
      const tours =
        await this.employeeDateTourControllerRequestService.multiplePlacerTours(
          requestObjects
        );
      if (!this.atLeastOneTourItem(tours)) {
        this.snackService.showWarning(
          'Geen toeren gevonden voor de opgegeven installateurs en datums'
        );
      } else {
        this.requestedTours.emit(tours);
      }
    } finally {
      this.loading = false;
    }
  }

  private atLeastOneTourItem(tours: Tour[]): boolean {
    return (
      CollectionHelper.isPopulated(tours) &&
      tours.some((t) => CollectionHelper.isPopulated(t.tourItems))
    );
  }

  compareEntities(o1: Employee, o2: Employee): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }
}
